// extracted by mini-css-extract-plugin
export default {"entityCardTitle":"EntityModal_entityCardTitle__KXjpd"};